import type {
  ComponentValueResponse,
  PortfolioSustainabilityStateResponse,
  SaveComponentValueResponse,
  SustainabilityComponentInput,
} from "@repo/shared/types";
import { getWithToken, postWithToken } from "../_client";

const BASE = "/public/flow";

export function getPublicSustainabilityValue(token: string) {
  return getWithToken<ComponentValueResponse>(`${BASE}/sustainability/flow-instance-value`, token);
}

export function savePublicSustainability(token: string, input: SustainabilityComponentInput) {
  return postWithToken<SaveComponentValueResponse>(
    `${BASE}/sustainability/flow-instance-value`,
    token,
    input satisfies SustainabilityComponentInput,
  );
}

export function getPublicPortfolioSustainabilityState(token: string, portfolioId: string) {
  return getWithToken<PortfolioSustainabilityStateResponse>(
    `${BASE}/portfolios/${portfolioId}/sustainability-state`,
    token,
  );
}
